import React from "react";

// Chakra imports
import { Flex, useColorModeValue,Image } from "@chakra-ui/react";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      <Image src="./prowess-logo.png" h="45px" my="20px" alt="PROWESS ERP Logo" />
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
